import theme from 'tailwindcss/defaultTheme';
import { useMediaQuery } from 'usehooks-ts';

const breakpoints = theme.screens;

function useIsMobile() {
  return useMediaQuery(`(max-width: ${breakpoints.md})`);
}

export { useIsMobile };
